<template>
  <organism-configuration-template
    v-if="!isLoading && filterData"
    :filterList="filterData"
    :tagOption="tagOption"
    :fields="fields"
    :items="templateList"
    @onUpdateFilterData="onUpdateFilterData"
    @onUpdateCurrentPage="onUpdateCurrentPage"
    @onSetDefaultFilterData="onSetDefaultFilterData"
    @deleteTemplate="deleteTemplate"
  ></organism-configuration-template>
</template>

<script>
import { getTemplateList, getTagsList, deleteTemplate } from "@/api/api-module4"
import { mapActions, mapGetters } from "vuex"
import mixins from "@/mixins"
import OrganismConfigurationTemplate from "@/components/organisms/networkConfigurationManagement/OrganismConfigurationTemplate.vue"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

export default {
  name: "ConfigurationTemplate",
  components: { OrganismConfigurationTemplate },
  mixins: [mixins, mixinsObjectHelper],
  data() {
    return {
      tagOption: null,

      fields: [
        {
          key: "template",
          label: "TEMPLATE NAME",
          // thClass: "w-25px",
          // tdClass: "w-25px",
        },
        {
          key: "description",
          label: "DESCRIPTION",
          // thClass: "w-25px",
          // tdClass: "w-25px",
        },
        {
          key: "actionIcon",
          label: "",
          // thClass: "w-25px",
          // tdClass: "w-25px",
        },
      ],

      templateList: null,
      filterData: null,
    }
  },
  computed: {
    ...mapGetters("appFilter", ["getNCMConfigTemplateFilter"]),

    isLoading() {
      return !this.templateList || !this.tagOption
    },
  },
  async created() {
    await this.getDataFromApi()
  },
  methods: {
    ...mapActions("appFilter", ["setNCMConfigTemplateFilter"]),

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getNCMConfigTemplateFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    // get data from api
    async getDataFromApi() {
      await Promise.all([
        this.getTagsListFromApi(),
        this.getTemplateListFromApi(),
      ])
    },

    async getTemplateListFromApi() {
      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      const filterData = this.filterDecoration()
      await getTemplateList(filterData)
        .then((response) => {
          this.filterData.totalCount = response.totalCount
          const updatedFilter = {
            ...this.getNCMConfigTemplateFilter,
            totalCount: response.totalCount,
          }
          this.setNCMConfigTemplateFilter(updatedFilter)
          this.templateList = response.data.map((template) => {
            return {
              id: template.configTemplateId,
              template: {
                name: template.configTemplateName,
                tag: template.tags,
              },
              description: template.configTemplateDescription,
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    filterDecoration() {
      const filter = {
        PageSize: 10,
        PageNumber: this.filterData.currentPage,
        Tags: this.filterData.tag
          ? this.filterData.tag.map((item) => item.toUpperCase())
          : undefined,
        Search: this.filterData.filter || undefined,
      }
      return filter
    },

    // click filter
    onUpdateFilterData(filter) {
      filter.currentPage = 1
      this.setNCMConfigTemplateFilter(filter)
      this.getTemplateListFromApi()
    },

    onUpdateCurrentPage(filter) {
      const updatedFilter = {
        currentPage: filter.currentPage,
        ...this.getNCMConfigTemplateFilter,
      }
      this.setNCMConfigTemplateFilter(updatedFilter)
      this.getTemplateListFromApi()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        filter: "",
        tag: null,
        currentPage: 1,
        totalCount: 0,
      }
      this.setNCMConfigTemplateFilter(defaultFilter)
      this.getTemplateListFromApi()
    },

    async getTagsListFromApi() {
      this.showLoading(true)
      this.tagOption = []
      await getTagsList()
        .then((tags) => {
          this.tagOption = tags
        })
        .finally(() => this.showLoading(false))
    },

    async deleteTemplate(id) {
      this.showLoading(true)
      await deleteTemplate(id)
        .then(async (response) => {
          if (response.status === "ok") {
            this.toastSuccess("Template deleted successfully")

            await this.getTemplateListFromApi()
          } else {
            this.toastError("Template deleted failed")
          }
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
